import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import { getCalculateCoefXQuery } from "./queries";

const CoefCalculatorContext = createContext({});

export const useCoefCalculatorContext = () => useContext(CoefCalculatorContext);
export const CoeffXCalculatorProvider = ({ ...props }) => {
  const [coefCalculatorResult, setCoefCalculatorResult] = useState([]);
  const getCalculateCoefX = useCallback(
    async ({ amount }) => {
      try {
        setCoefCalculatorResult(
          await getCalculateCoefXQuery({
            amount,
          })
        );
      } catch (e) {
        console.error("coefCalculatorResultGetter", e);
        throw e;
      }
    },
    [coefCalculatorResult]
  );
  const values = useMemo(
    () => ({
      getCalculateCoefX,
      setCoefCalculatorResult,
      coefCalculatorResult,
    }),
    [coefCalculatorResult]
  );

  return <CoefCalculatorContext.Provider value={values} {...props} />;
};
